import { render, staticRenderFns } from "./RegisterLast.vue?vue&type=template&id=42956aac&scoped=true"
import script from "./RegisterLast.vue?vue&type=script&lang=js"
export * from "./RegisterLast.vue?vue&type=script&lang=js"
import style0 from "./RegisterLast.vue?vue&type=style&index=0&id=42956aac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42956aac",
  null
  
)

export default component.exports